import { CanDeactivateFn } from '@angular/router';
import { OfferFormPageComponent } from './offer-form-page.component';

/**
 * Empêche de quitter le formulaire d'offre (création/édition, route standalone) avec des
 * modifications non enregistrées sans confirmation explicite -- voir
 * `OfferFormPageComponent#canDeactivate` pour la logique (frappe perdue silencieusement, audit QA).
 */
export const unsavedOfferFormGuard: CanDeactivateFn<OfferFormPageComponent> = (component) => component.canDeactivate();
